import { client } from './client';

export const reportApi = {
  getDailyReport: () => client.get('get_daily_report'),
  addEmptyDailyReport: () => client.get('add_empty_daily_report'),
  updateDailyReport: (params) => client.get('update_daily_report', { params }),
  saveDailyReport: (params) => client.get('save_daily_report', { params }),
  isDailyReportLocked: () => client.get('is_daily_report_locked'),
  getEmployeeDoneItems: () => client.get('get_employee_done_items'),
  saveDailyReportSelectedItems: (params) => client.get('save_daily_report_selected_items', { params }),
  removeDailyReport: (params) => client.get('remove_daily_report', { params }),
  managerGetDepartmentEmployee: () => client.get('manager_get_department_employee'),
  managerGetDailyReport: (params) => client.get('manager_get_daily_report', { params }),
  approveDailyReport: (params) => client.get('approve_daily_report', { params }),
  getDistanceReport: (params) => client.get('get_distance_report', { params }),
  getPresenceReport: (params) => client.get('get_presence_report', { params }),
  getActivationHistory: () => client.get('get_activation_history'),
  getDailyReportItems: () => client.get('get_daily_report_items'),
  addDailyReportItem: (data) => client.post('add_daily_report_item', data),
  editDailyReportItem: (data) => client.post('edit_daily_report_item', data),
  deleteDailyReportItem: (itemId) => client.get('delete_daily_report_item', { params: { item_id: itemId } }),
  createFinanceInvoiceTicket: (data) => client.post('create_daily_report_invoice', data),
  createDailyReportInvoice: (data) => client.post('create_daily_report_invoice', data),
  getDailyReportInvoices: (params) => client.get('get_daily_report_invoices', { params }),
  getNextInvoiceNumber: () => client.get('get_next_invoice_number'),
  getCompanyInvoiceDefaults: (params) => client.get('get_company_invoice_defaults', { params }),
  getDailyReportInvoiceDetail: (params) => client.get('get_daily_report_invoice_detail', { params }),
  priceDailyReportInvoice: (data) => client.post('price_daily_report_invoice', data),
  updateDailyReportInvoice: (data) => client.post('update_daily_report_invoice', data),
  approveDailyReportInvoice: (data) => client.post('approve_daily_report_invoice', data),
  finalizeDailyReportInvoice: (data) => client.post('finalize_daily_report_invoice', data),
  getDailyReportRouting: () => client.get('get_daily_report_routing'),
  saveDailyReportRouting: (data) => client.post('save_daily_report_routing', data),
  getAccountingBridgeConfig: () => client.get('get_accounting_bridge_config'),
  saveAccountingBridgeConfig: (data) => client.post('save_accounting_bridge_config', data),
  testAminConnection: () => client.get('test_amin_connection'),
  getAminProducts: (params) => client.get('get_amin_products', { params }),
  getAminCustomers: (params) => client.get('get_amin_customers', { params }),
};
